module.exports = __webpack_public_path__ + "img/altegio.5a2702e3.png";